import React from 'react';
import { useDispatch } from 'react-redux';
import { accountRoles } from 'lib/constants';
import { dispatchHideModal, dispatchShowModal } from 'utils/modals';
import {
    STATUS_CARD_MODAL,
    REPLACEMENT_CARD_FEE,
    // LSD_STATUS_CARD_MODAL,
    ISSUE_CARD_MODAL,
} from 'constants/shared/modalTypes';
import DisabledCard from '../../cardTypes/DisabledCard';
import PlaceholderCard from '../../cardTypes/PlaceholderCard';
import IssuedCard from '../../cardTypes/IssuedCard';
import NewCard from '../../cardTypes/NewCard';
import { useIssueCardMutation, useGetCardsQuery } from 'lib/services';
import { useRestrictedAction } from '../../../../../hooks';
import { CardStatus, ICard, IAccount } from 'lib/type';

interface CardProps {
    card: ICard | null;
    account: IAccount;
    position: string;
}

const Card: React.FC<CardProps> = ({ card, account, position }) => {
    const dispatch = useDispatch();
    const { isFetching } = useGetCardsQuery();
    const [issueCardMutation] = useIssueCardMutation();
    const { handleRestrictedAction } = useRestrictedAction();

    const handleReportStatus = () => {
        handleRestrictedAction(() =>
            dispatchShowModal(dispatch, REPLACEMENT_CARD_FEE, {
                handleSubmit: handleShowReplacementCardModal,
                closeModal: () => dispatchHideModal(dispatch),
            }),
        );
    };

    const handleAddCardHolderClick = () => {
        handleRestrictedAction(() =>
            dispatchShowModal(dispatch, ISSUE_CARD_MODAL, {
                handleSubmit: () => issueCardMutation(),
                closeModal: () => dispatchHideModal(dispatch),
            }),
        );
    };

    const handleShowReplacementCardModal = () => {
        dispatchShowModal(dispatch, STATUS_CARD_MODAL, {
            cardSerial: card?.cardSerial,
            account: account,
        });
    };

    // const handleReportLSDStatus = () => {
    //     dispatchShowModal(dispatch, REPLACEMENT_CARD_FEE, {
    //         fee: allFees.replacementCard,
    //         handleSubmit: handleShowLSDReplacementCardModal,
    //         closeModal: () => dispatchHideModal(dispatch),
    //     });
    // };
    // const handleShowLSDReplacementCardModal = () => {
    //     dispatchShowModal(dispatch, LSD_STATUS_CARD_MODAL, {
    //         cardSerial: card.cardSerial,
    //     });
    // };

    const isDarkText = account.productType === accountRoles.Essential;

    if (!card) {
        return <PlaceholderCard />;
    }

    const { status } = card;
    const isDisabled =
        status === CardStatus.RISK || status === CardStatus.TERMINATED;

    if (isDisabled)
        return (
            <DisabledCard
                status={status}
                position={position}
                onClick={handleReportStatus}
                isDarkText={isDarkText}
            />
        );

    if (status === CardStatus.ISSUED)
        return (
            <IssuedCard
                position={position}
                card={card}
                isDarkText={isDarkText}
            />
        );

    if (status === 'N' && !isFetching)
        return (
            <NewCard
                onAddCardHolderClick={handleAddCardHolderClick}
                isDarkText={isDarkText}
            />
        );

    //NOTE: Currently we don't show the L, S and D cards in the carousel, but this component is kept for future use.
    // if ([LOST, STOLEN, DAMAGED].includes(status))
    //     return (
    //         <EndedCard
    //             position={position}
    //             card={card}
    //             onClick={handleReportLSDStatus}
    //             isDarkText={isDarkText}
    //         />
    //     );

    return null;
};

export default Card;
